var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuts2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 450,
    height: 450,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 225,
    cy: 225,
    r: 225
  }), /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 225,
    cy: 225,
    r: 225
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e",
    cx: 225,
    cy: 225,
    r: 225
  }), /*#__PURE__*/React.createElement("circle", {
    id: "g",
    cx: 225,
    cy: 225,
    r: 225
  }), /*#__PURE__*/React.createElement("circle", {
    id: "i",
    cx: 225,
    cy: 225,
    r: 225
  }), /*#__PURE__*/React.createElement("circle", {
    id: "k",
    cx: 225,
    cy: 225,
    r: 225
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M0 0c120.398 0 218 97.602 218 218S120.398 436 0 436z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 225,
    r: 225,
    fill: "#545BFE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4FCDF9",
    fillRule: "nonzero",
    d: "M134 351c6.627 0 12-5.373 12-12s-5.373-12-12-12h-19c-6.627 0-12-5.373-12-12s5.373-12 12-12h-2c6.627 0 12-5.373 12-12s-5.373-12-12-12h-10c-6.627 0-12-5.373-12-12s5.373-12 12-12 12-5.373 12-12-5.373-12-12-12-12-5.373-12-12 5.373-12 12-12h49c6.627 0 12 5.373 12 12s-5.373 12-12 12h2v.01c-6.395.263-11.5 5.53-11.5 11.99s5.105 11.727 11.5 11.99v.01h51c6.627 0 12 5.373 12 12s-5.373 12-12 12h-6v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01c6.627 0 12 5.373 12 12s-5.373 12-12 12h-27v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01h-4c6.627 0 12 5.373 12 12s-5.373 12-12 12h-29c-6.627 0-12-5.373-12-12s5.373-12 12-12h-5zM49 183c6.627 0 12 5.373 12 12s-5.373 12-12 12H14c-6.627 0-12-5.373-12-12s5.373-12 12-12h35zm49-24c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm78-144c6.627 0 12 5.373 12 12s-5.373 12-12 12h-1v.01c-6.395.263-11.5 5.53-11.5 11.99s5.105 11.727 11.5 11.99V63h7c6.627 0 12 5.373 12 12s-5.373 12-12 12h-69v.01c-6.395.263-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01h5c6.627 0 12 5.373 12 12s-5.373 12-12 12H-1c-6.627 0-12-5.373-12-12s5.373-12 12-12H9c6.627 0 12-5.373 12-12S15.627 87 9 87h4C6.373 87 1 81.627 1 75s5.373-12 12-12h6c6.627 0 12-5.373 12-12s-5.373-12-12-12h-48c-6.627 0-12-5.373-12-12s5.373-12 12-12h205z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4FCDF9",
    fillRule: "nonzero",
    d: "M390 327c6.627 0 12-5.373 12-12s-5.373-12-12-12-12-5.373-12-12 5.373-12 12-12h-3c6.627 0 12-5.373 12-12s-5.373-12-12-12h-45c-6.627 0-12-5.373-12-12s5.373-12 12-12 12-5.373 12-12-5.373-12-12-12h-34c-6.627 0-12-5.373-12-12s5.373-12 12-12h26c6.627 0 12-5.373 12-12s-5.373-12-12-12-12-5.373-12-12 5.373-12 12-12h56c6.627 0 12 5.373 12 12s-5.373 12-12 12l-.001.01c-6.395.263-11.499 5.53-11.499 11.99s5.104 11.727 11.499 11.99l.001.01h91c6.627 0 12 5.373 12 12s-5.373 12-12 12h-20v.01c-6.395.263-11.5 5.53-11.5 11.99s5.105 11.727 11.5 11.99v.01h10c6.627 0 12 5.373 12 12s-5.373 12-12 12h-15l-.001.01c-6.395.263-11.499 5.53-11.499 11.99s5.104 11.727 11.499 11.99l.001.01h-2c6.627 0 12 5.373 12 12s-5.373 12-12 12h-20v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01h-4c6.627 0 12 5.373 12 12s-5.373 12-12 12h-36c-6.627 0-12-5.373-12-12s5.373-12 12-12h-4zm90-24c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm-18-168c6.627 0 12 5.373 12 12s-5.373 12-12 12h-14c-6.627 0-12-5.373-12-12s5.373-12 12-12h14zm198-72c6.627 0 12 5.373 12 12s-5.373 12-12 12h-7v.01c-6.395.263-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01h16c6.627 0 12 5.373 12 12s-5.373 12-12 12H495c-6.627 0-12-5.373-12-12s5.373-12 12-12h-5c6.627 0 12-5.373 12-12s-5.373-12-12-12h-41c-6.627 0-12-5.373-12-12s5.373-12 12-12h211zM359 87c6.627 0 12 5.373 12 12s-5.373 12-12 12h-24c-6.627 0-12-5.373-12-12s5.373-12 12-12h24zm38 0c6.627 0 12 5.373 12 12s-5.373 12-12 12h-3c-6.627 0-12-5.373-12-12s5.373-12 12-12h3zm13-48c6.627 0 12 5.373 12 12s-5.373 12-12 12h-24c-6.627 0-12-5.373-12-12s5.373-12 12-12h24z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M413 111c6.627 0 12 5.373 12 12s-5.373 12-12 12h-62c-6.627 0-12-5.373-12-12s5.373-12 12-12h62zM307 51c0-6.627-5.373-12-12-12H175c-6.627 0-12-5.373-12-12s5.373-12 12-12h49c6.627 0 12-5.373 12-12s-5.373-12-12-12h-16c-6.627 0-12-5.373-12-12s5.373-12 12-12h62c6.627 0 12 5.373 12 12s-5.373 12-12 12h2v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99V15h160c6.627 0 12 5.373 12 12s-5.373 12-12 12h-68l-.001.01c-6.395.263-11.499 5.53-11.499 11.99S357.604 62.727 364 62.99L364 63h3c6.627 0 12 5.373 12 12s-5.373 12-12 12h-76c-6.627 0-12-5.373-12-12s5.373-12 12-12h4c6.627 0 12-5.373 12-12zm128 12c6.627 0 12 5.373 12 12s-5.373 12-12 12h-20c-6.627 0-12-5.373-12-12s5.373-12 12-12h20zm-192 0c6.627 0 12 5.373 12 12s-5.373 12-12 12h-20c-6.627 0-12-5.373-12-12s5.373-12 12-12h20zm231-96c6.627 0 12 5.373 12 12s-5.373 12-12 12H318c-6.627 0-12-5.373-12-12s5.373-12 12-12h156z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M97 363c0-6.627-5.373-12-12-12H17c-6.627 0-12-5.373-12-12s5.373-12 12-12h101c6.627 0 12-5.373 12-12s-5.373-12-12-12H95c-6.627 0-12-5.373-12-12s5.373-12 12-12h118c6.627 0 12 5.373 12 12s-5.373 12-12 12h-47v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01h14c6.627 0 12 5.373 12 12s-5.373 12-12 12h-26l-.001.01c-6.395.263-11.499 5.53-11.499 11.99s5.104 11.727 11.499 11.99l.001.01h3c6.627 0 12 5.373 12 12s-5.373 12-12 12H81c-6.627 0-12-5.373-12-12s5.373-12 12-12h4c6.627 0 12-5.373 12-12zm151-36c6.627 0 12 5.373 12 12s-5.373 12-12 12h-20c-6.627 0-12-5.373-12-12s5.373-12 12-12h20z",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M349 459c0-6.627-5.373-12-12-12h-68c-6.627 0-12-5.373-12-12s5.373-12 12-12h101c6.627 0 12-5.373 12-12s-5.373-12-12-12h-23c-6.627 0-12-5.373-12-12s5.373-12 12-12h118c6.627 0 12 5.373 12 12s-5.373 12-12 12h-47v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01h14c6.627 0 12 5.373 12 12s-5.373 12-12 12h-26l-.001.01c-6.395.263-11.499 5.53-11.499 11.99s5.104 11.727 11.499 11.99l.001.01h3c6.627 0 12 5.373 12 12s-5.373 12-12 12h-76c-6.627 0-12-5.373-12-12s5.373-12 12-12h4c6.627 0 12-5.373 12-12zm151-36c6.627 0 12 5.373 12 12s-5.373 12-12 12h-20c-6.627 0-12-5.373-12-12s5.373-12 12-12h20z",
    mask: "url(#j)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    mask: "url(#l)",
    opacity: 0.078,
    d: "M225.484-25h250.484v500H225.484z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(225 7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#2A2D80",
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 219.5,
    r: 208.5,
    fill: "#952525",
    mask: "url(#n)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 218,
    r: 178,
    fill: "#E0592F",
    mask: "url(#n)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 218,
    r: 107,
    fill: "#F89035",
    mask: "url(#n)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 219,
    r: 51,
    fill: "#FFF1AA",
    mask: "url(#n)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuts2);
export default __webpack_public_path__ + "static/media/Guts2.3c465186cd11e28615059f051f8ab2c6.svg";
export { ForwardRef as ReactComponent };